<template>
    <custom-drawer
        size="800px"
        :wrapper_closable="false"
        :confirm_to_close="false"
        :visible.sync="visible_in_line"
    >
        <template slot="title">
            <div class="flex items-center h-full pl-4 pr-8 space-x-4">
                <p class="font-semibold">
                    {{ $t('page.campaign.auth_tiktok_post') }}
                </p>

                <div class="!ml-auto"></div>

                <el-button
                    icon="el-icon-check"
                    type="primary"
                    size="small"
                    :disabled="multiple_selection.length === 0"
                    @click="handleChooseVideoForAd"
                >
                    {{ $t('button.confirm') }}
                </el-button>
            </div>
        </template>

        <div
            v-loading="m__loading"
            class="h-full pt-4 pb-8 pl-[84px] pr-12 overflow-auto bg-white"
        >
            <div class="flex space-x-2">
                <label-outside-input-select :label="$t('common.auth_code')">
                    <el-input
                        v-model="auth_code"
                        type="text"
                        size="small"
                        class="w-[440px]"
                        :clearable="true"
                        :placeholder="$t('input.placeholder.please_input')"
                    >
                        <el-button
                            slot="append"
                            icon="el-icon-search"
                            @click="findTiktokPostByCode"
                        ></el-button>
                    </el-input>
                </label-outside-input-select>
            </div>

            <div v-if="data_list.length" class="flex flex-wrap gap-4 mt-4">
                <div v-for="item in data_list" :key="item.item_id">
                    <div
                        class="w-[180px] relative h-[180px] group"
                        :class="[
                            handleHasChoosen(item.item_id)
                                ? ''
                                : 'hover:opacity-80'
                        ]"
                    >
                        <div
                            class="w-auto h-full rounded-lg cursor-pointer relative border-[1px]"
                            :class="[
                                handleHasChoosen(item.item_id)
                                    ? 'border-brand-atosa'
                                    : 'border-transparent bg-bg'
                            ]"
                            @click="handleChooseVideo(item)"
                        >
                            <div
                                v-if="handleHasChoosen(item.item_id)"
                                class="bg-brand-atosa opacity-20 absolute top-0 left-0 z-20 w-full h-full"
                            ></div>

                            <img
                                :src="item.video_info.poster_url"
                                class="object-contain w-full h-full"
                                alt=""
                            />

                            <div class="top-1 right-2 absolute">
                                <el-checkbox
                                    :value="handleHasChoosen(item.item_id)"
                                    @input="handleChooseVideo(item)"
                                ></el-checkbox>
                            </div>

                            <div
                                class="absolute bottom-2 right-2 bg-black p-[2px] rounded-xl"
                            >
                                <p class="text-xxs text-white">
                                    {{
                                        p__renderDurationToMinute(
                                            item.video_info.duration
                                        )
                                    }}
                                </p>
                            </div>
                        </div>

                        <div
                            class="top-1/2 left-1/2 w-7 h-7 group-hover:w-8 group-hover:h-8 util-flex-center absolute z-40 -translate-x-1/2 -translate-y-1/2 bg-black rounded-full cursor-pointer"
                            @click="
                                handleChooseVideoToShow(item.video_info.url)
                            "
                        >
                            <i
                                class="el-icon-caret-right text-xl text-white"
                            ></i>
                        </div>
                    </div>

                    <p class="text-xs truncate w-[180px]">
                        {{ item.text }}
                    </p>
                </div>
            </div>

            <div v-else class="util-flex-center mt-14 flex-col">
                <img
                    class="w-[140px] h-[140px]"
                    :src="require('@/assets/images/no_data.png')"
                />
                <p class="text-desc-text mt-4 text-sm">
                    {{ $t('common.no_data') }}
                </p>
            </div>
        </div>

        <InfoVideoDialog
            :visible.sync="show_info_video_dialog"
            :preview_url="preview_url"
        ></InfoVideoDialog>

    </custom-drawer>
</template>

<script>
import paginationDataMixin from '@/plugins/mixins/pagination-data'
import {
    ApplyTiktokPost,
    getInfoTiktokPost
} from '@/services/atosa-tiktok-ads/auth_tiktok_posh'
import { getVideoFromIdentity } from '@/services/atosa-tiktok-ads/identity'

export default {
    mixins: [paginationDataMixin],

    props: [
        'visible',
        'advertiser_id',
        'tiktok_account_id',
        'belong_to_atosa',
        'identity_id',
        'identity_authorized_bc_id',
        'identity_type'
    ],

    data() {
        return {
            show_info_video_dialog: false,
            has_more: false,
            multiple_selection: [],
            preview_url: '',
            search_title: '',
            data_list: [],
            filter_status: 'ALL',
            status_options: [
                {
                    value: 'ALL',
                    label: this.$t('common.all')
                },
                {
                    value: 'ITEM_STATUS_HESITATE_RECOMMEND',
                    label: this.$t(
                        'page.campaign.campaign_status_tiktok_post_hesitate_recommend'
                    )
                },
                {
                    value: 'STATUS_ONLY_FRIEND_SEE',
                    label: this.$t(
                        'page.campaign.campaign_status_tiktok_post_only_friend_see'
                    )
                },
                {
                    value: 'ITEM_STATUS_ONLY_AUTHOR_SEE',
                    label: this.$t(
                        'page.campaign.campaign_status_tiktok_post_only_author_see'
                    )
                }
            ],
            auth_code: ''
        }
    },

    computed: {
        visible_in_line: {
            get: function () {
                return this.visible
            },
            set: function (val) {
                this.$emit('update:visible', val)
            }
        }
    },

    watch: {
        identity_id() {},

        visible_in_line() {
            if (this.visible_in_line) {
                this.multiple_selection = []
            }
        }
    },

    mounted() {},

    methods: {
        handleChooseVideoToShow(url) {
            this.preview_url = url
            this.show_info_video_dialog = true
        },

        handleChooseVideo(video) {
            if (
                this.multiple_selection.some(
                    (item) => item.item_id === video.item_id
                )
            ) {
                this.multiple_selection = this.multiple_selection.filter(
                    (item) => item.item_id !== video.item_id
                )
            } else {
                this.multiple_selection = [...this.multiple_selection, video]
            }
        },

        handleRefresh() {
            this.has_more = false
            this.multiple_selection = []
        },

        handleHasChoosen(item_id) {
            return this.multiple_selection.some(
                (item) => item.item_id === item_id
            )
        },

        handleChooseVideoForAd() {
            console.log('vào đấy dá', this.multiple_selection)

            if (!this.multiple_selection.length) {
                return
            }

            this.$emit('choose_video_from_auth_post', this.multiple_selection)

            this.multiple_selection = []

            this.visible_in_line = false
        },

        handleScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
            if (this.m__loading) {
                return
            }
        },
        async findTiktokPostByCode() {
            this.m__loading = true

            try {
                await ApplyTiktokPost(this.tiktok_account_id, {
                    advertiser_id: this.advertiser_id,
                    auth_code: this.auth_code
                })

                const response = await getInfoTiktokPost(
                    this.tiktok_account_id,
                    {
                        advertiser_id: this.advertiser_id,
                        auth_code: this.auth_code
                    }
                )

                const item_data = {
                    ...response.data.item_info,
                    video_info: response.data.video_info,
                    user_info: response.data.user_info
                }

                this.data_list = [
                    {
                        ...item_data
                    }
                ]
                console.log(response, item_data, 'dálkfdajsl')
            } catch (error) {
                console.error(error)
            }

            this.m__loading = false
        }
    }
}
</script>
